import React from "react";
import {
  Empty, Spin, Table, Tooltip,
} from "antd";
import { BATCH_REPORT_TEST_STATUS } from "../../../utils/statusConfig";
import "../QC/MarkSampleQCModal/components/MarkSampleQCModal.css";
import "../ReportDelay/UpdateDelayReportModal.css";

const renderResultStatus = (text) => {
  const key = text == null || String(text).trim() === "" ? "-" : String(text).trim();
  const statusConfig = BATCH_REPORT_TEST_STATUS[key];
  if (!statusConfig) {
    return <span>{key}</span>;
  }
  return <span style={statusConfig.style}>{key}</span>;
};

const DISPLAY_COLUMNS = [
  {
    title: "Customer ID",
    dataIndex: "customer_id",
    key: "customer_id",
    render: (text, record) => (
      <Tooltip placement="top" title={record.company_name}>
        <span>{text}</span>
      </Tooltip>
    ),
  },
  {
    title: "WO ID",
    dataIndex: "workorder_id",
    key: "workorder_id",
    render: (text, record) => (
      <div>
        <span>{text}</span>
        {record.wo_type === "auto" && (
          <span className="MarkSampleQCModal__MainWorkorderText">(Auto Retest)</span>
        )}
        {record.is_retest === false && (
          <span className="MarkSampleQCModal__MainWorkorderText">(Original)</span>
        )}
      </div>
    ),
  },
  {
    title: "Genista ID",
    dataIndex: "genista_id",
    key: "genista_id",
    render: (text, record) => (
      <Tooltip placement="top" title={record.sample_id}>
        <span>{text}</span>
      </Tooltip>
    ),
  },
  {
    title: "Sample Type",
    dataIndex: "sample_type",
    key: "sample_type",
  },
  {
    title: "Test",
    dataIndex: "analysis",
    key: "analysis",
  },
  {
    title: "Result",
    dataIndex: "result",
    key: "result",
    render: (text) => text ?? "-",
  },
  {
    title: "Status",
    dataIndex: "result_status",
    key: "result_status",
    render: renderResultStatus,
  },
];

/**
 * Read-only related workorders table (QC columns: Customer ID → Status), no expand/actions.
 */
export default function RcaRelatedWorkorderTable({
  rows = [],
  loading = false,
  title = "Related Work Order Details",
}) {
  const sectionTitle = <label>{title}</label>;

  if (loading) {
    return (
      <div className="UpdateDelayReportModal__Field">
        {sectionTitle}
        <Spin tip="Loading related workorders..." />
      </div>
    );
  }

  if (!rows.length) {
    return (
      <div className="UpdateDelayReportModal__Field">
        {sectionTitle}
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="No related workorder data"
        />
      </div>
    );
  }

  return (
    <div className="UpdateDelayReportModal__Field">
      {sectionTitle}
      <Table
        rowKey="key"
        columns={DISPLAY_COLUMNS}
        dataSource={rows}
        pagination={false}
        bordered
        size="middle"
        scroll={{ x: "max-content" }}
      />
    </div>
  );
}
